import { Component } from '@angular/core';

@Component({
  selector: 'app-splash2',
  templateUrl: './splash2.component.html',
  styleUrls: ['./splash2.component.scss']
})
export class Splash2Component {
chartType = 'doughnut';

  chartDatasets = [
    { data: [85, 10, 5], label: 'My First dataset' }
  ];

  chartLabels = ['Bajos recursos (sin seguro)', 'Con cobertura parcial', 'Población general'];

  chartColors = [
    {
      backgroundColor: ['#2C60A4', '#5DB5D1', '#B4D26B'],
      hoverBackgroundColor: ['#2C60A4', '#5DB5D1', '#B4D26B'],
      borderWidth: 2,
    }
  ];

  chartOptions: any = {
    responsive: true
  };

  chartClicked(event: any): void {
    console.log(event);
  }

  chartHovered(event: any): void {
    console.log(event);
  }
}